/*jshint esversion: 6 */
import React from 'react';
import { connect } from 'react-redux';
import { PostGroupActions } from 'app/redux/actions.js';

function mapStateToProps(state) {
    return({
        postgroups: state.postgroups
    });
}

function mapDispatchToProps(dispatch) {
    return {
        getPostGroups: () => {
            dispatch(PostGroupActions.fetchPostGroups());
        },
        getPostGroup: (id) => {
            dispatch(PostGroupActions.fetchPostGroup(id));
        },
        updatePostGroup: (postgroup) => {
            dispatch(PostGroupActions.updatePostGroup(postgroup));
        },
        deletePostGroup: (id) => {
            dispatch(PostGroupActions.deletePostGroup(id));
        },
        createPostGroup: (postgroup) => {
            dispatch(PostGroupActions.createPostGroup(postgroup));
        }
	};
}

export default function PostGroupProvider(Component) {

    class PostGroupProvider extends React.Component {
        render() {
            return (
                <Component {...this.props}/>
            );
        }
    }

    PostGroupProvider.displayName = "PostGroupProvider";

    return connect(mapStateToProps, mapDispatchToProps)(PostGroupProvider);
};
